export default [
    {
      name: "First place prize",
      amount:  1000,
      pullPercentage: 0
    },
    {
      name: "Second place prize",
      amount: 800,
      pullPercentage: 0,
    },
    {
      name: "Third place prize",
      amount: 0,
      pullPercentage: 10
    },
  ];
  